import { AfterViewInit, Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'ngx-bar-chart',
  template: `
    <div id="main" style="width: 100%; height: 335px;"></div>
  `
})
export class BarChartComponent implements AfterViewInit {
  @Input() chartOptions: EChartsOption = {};

  ngAfterViewInit(): void {
    const chartDom = document.getElementById('main')!;
    const myChart = echarts.init(chartDom);
    myChart.setOption(this.chartOptions);
  }

}
